import { HttpStatusCode, type HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { CODIGO_ERRORES_HTTP, LIMITE_SOLICITUDES } from '@core/constants/codigo-errores-http';
import { HTTP_HEADERS } from '@core/constants/http-headers.constants';
import { catchError, throwError } from 'rxjs';
import { ToastService, TOAST_SEVERITY } from '@shared/servicios/toast.service';
import { inject } from '@angular/core';

const CODIGOS_MENSAJE_GENERICO = new Set([HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden]);

const mensajeLimiteSolicitudes = (error: HttpErrorResponse): string => {
  const segundosEspera = Number(error.headers?.get(HTTP_HEADERS.RETRY_AFTER));

  return Number.isInteger(segundosEspera) && segundosEspera > 0
    ? LIMITE_SOLICITUDES.mensajeConEspera(segundosEspera)
    : CODIGO_ERRORES_HTTP[HttpStatusCode.TooManyRequests];
};

export const erroresHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let mensajeError: string;

      if (error.error instanceof ProgressEvent) {
        mensajeError = CODIGO_ERRORES_HTTP.desconectado;
      } else if (CODIGOS_MENSAJE_GENERICO.has(error.status)) {
        mensajeError = CODIGO_ERRORES_HTTP[error.status];
      } else if (error.status === HttpStatusCode.TooManyRequests) {
        mensajeError = error.error?.message || mensajeLimiteSolicitudes(error);
      } else {
        mensajeError = error.error?.message || error.error?.ErrorMessage || CODIGO_ERRORES_HTTP[error.status] || CODIGO_ERRORES_HTTP.desconocido;
      }

      toastService.mostrar(mensajeError, TOAST_SEVERITY.error);

      return throwError(() => error);
    })
  );
};
